import type { ReduxApplicationState } from '../combinedReducer';

export const selectProductReviews = (state: ReduxApplicationState) => state.reviews;
